import "./ourStory.css"

export function OurStory() {
    return (
        <div className="d-flex align-items-center mb-5 our-story lg-row">

            <div className="pe-5">
                <p className="article-title">Our Story</p>
                <p>
                    Launced in 2015, Exclusive is South Asia’s premier online shopping
                    makterplace with an active presense in Bangladesh. Supported
                    by wide range of tailored marketing, data and service solutions,
                    Exclusive has 10,500 sallers and 300 brands and serves 3
                    millioons customers across the region.
                </p>
                <p>
                    Exclusive has more than 1 Million products to offer, growing at a
                    very fast. Exclusive offers a diverse assotment in categories
                    ranging from consumer.
                </p>
            </div>

            <div className="portrait-females">
                <img src="/images/portrait-african-females.jpg" className="rounded-1" alt="" />
            </div>

        </div>
    )
}